import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import { TableHeadSortingCell } from 'javascripts/analytics/components/table_head_sorting_cell';

export class ReferersTable extends React.Component {
  static propTypes = {
    refererPagePairs: PropTypes.array.isRequired,
    dayCount: PropTypes.number.isRequired,
  };

  state = {
    sortBy: 'thirtyDayViews',
    sortDirection: 'DESC',
  };

  updateSort = (sortBy) => {
    return function () {
      this.setState({
        sortBy: sortBy,
        sortDirection: this.state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
      });
    }.bind(this);
  };

  sortedPairs = () => {
    const pairs = _.sortBy(
      this.props.refererPagePairs,
      function (pair) {
        return _.result(pair, this.state.sortBy) || 0;
      },
      this,
    );

    if (this.state.sortDirection === 'ASC') return pairs;

    return _.clone(pairs).reverse();
  };

  render() {
    return (
      <div className="panel panel-flat a-fadeInDown">
        <div className="panel-body" style={{ overflowX: 'auto' }}>
          <table
            className="analytics-dashboard-data-table table table-bordered table-hover u-mb0x"
            style={{ tableLayout: 'auto' }}
          >
            <thead>
              <tr>
                <th className="col-xs-3">Page</th>
                <th className="col-xs-5">Referring site</th>

                <TableHeadSortingCell
                  sortingByColumn={this.state.sortBy === 'thirtyDayViews'}
                  sortDirection={this.state.sortDirection}
                  onClick={this.updateSort('thirtyDayViews')}
                  className="col-xs-2"
                >
                  {this.props.dayCount}-day views
                </TableHeadSortingCell>

                <TableHeadSortingCell
                  sortingByColumn={this.state.sortBy === 'allTimeViews'}
                  sortDirection={this.state.sortDirection}
                  onClick={this.updateSort('allTimeViews')}
                  className="col-xs-2"
                >
                  All-time views
                </TableHeadSortingCell>
              </tr>
            </thead>

            <tbody>
              {_.map(
                this.sortedPairs(),
                function (pair) {
                  return this.renderRefererPageRow(pair);
                },
                this,
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderRefererPageRow = (pair) => {
    return (
      <tr key={pair.workId + '-' + pair.refererUrl}>
        <td>
          <a
            href={pair.targetPageUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {pair.targetPageTitle}
          </a>
        </td>
        <td>
          <a
            href={pair.refererUrl}
            ref={this.initializeRefererTooltip(pair.refererUrl)}
          >
            {this.stripQueryParamsFromUrl(pair.refererUrl)}
          </a>
        </td>
        <td className="u-fontMonospaced u-fs12">
          {$h.commaizeInt(pair.thirtyDayViews || 0)}
        </td>
        <td className="u-fontMonospaced u-fs12">
          {$h.commaizeInt(pair.allTimeViews || 0)}
        </td>
      </tr>
    );
  };

  initializeRefererTooltip = (url) => {
    return function (el) {
      if (!el) return;
      $(el).tooltip({
        title: url,
      });
    };
  };

  stripQueryParamsFromUrl = (originalUrl) => {
    if (!originalUrl) return '';
    return originalUrl.split('?')[0];
  };
}
